import { TimelineMax } from '@/vendor';
import Ball from './Ball';

export default class Ornament extends Ball
{
    constructor( settings )
    {
        super( settings );

        this.name = 'ornament';

        this.sprite.x = 0;
        this.sprite.y = 0;
        this.sprite.cacheAsBitmap = false;

        this.sprite.width = 59;
        this.sprite.height = 67;

        let texture = PIXI.loader.resources[ 'ornament' ].texture;

        this.sprite.texture = texture;

        this.sprite.cacheAsBitmap = true;

        this.pos.x = this.sprite.x = settings.x;
        this.pos.y = this.sprite.y = settings.y;

        this.testGraphic.alpha = 0;
    }

    onClick( e )
    {
        this.sprite.cacheAsBitmap = false;
        let newTexture = PIXI.loader.resources[ 'ornament-broken' ].texture;
        this.sprite.texture = newTexture;

        this.sprite.width = 70 * 1.3;
        this.sprite.height = 70 * 1.3;
        this.sprite.cacheAsBitmap = true;

        this.eventHub.emit( 'ornamentSuicide' + this.id, this );
    }

    beforeDestroy()
    {
        return new Promise( resolve =>
        {
            this.testGraphic.alpha = 0;
            let tl = new TimelineMax({ onComplete: resolve, delay: 1 });
            tl.to( this.sprite, 0.3, { width: 0, height: 0, alpha: 0 }, 0 );
        });
    }

    fancyDeathAnim()
    {
        return new Promise( resolve =>
        {
            let tl = new TimelineMax({ onComplete: resolve });
            tl.to( this.sprite, 0.2, { alpha: 0, width: '+=10', height: '+=10', y: '-=10' }, 0 );
        });
    }

    async fancyRemove()
    {
        this.sprite.interactive = false;
        await this.fancyDeathAnim();
    }
}



// WEBPACK FOOTER //
// ./src/app/game/elements/Ornament.js